import React from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import {MembershipModes} from "../SubscriptionAssignmentEditor";

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    prompText: {
        marginTop: theme.spacing(2),
        height: '100%',
    },
    promptActions: {
        '& > *': {
            marginLeft: theme.spacing(1)
        }
    }
}));


const ChooseMembershipMode = ({
    onConfirm,
    onCancel
}: any) => {
    const classes = useStyles();
    const { t } = useTranslation();

       return <Grid container className={classes.root}>
                <Grid item xs={12} md={6} className={classes.prompText}>
                        <Typography variant='caption'>{t(`Subscription.SubscriptionAssignment.UserAlreadyHasSubscriptionOfTypeFromOrganization.Prompt`)}</Typography>
        </Grid>
                <Grid item container xs={12} md={6} justify='flex-end' alignItems='center' className={classes.promptActions}>
                        <Button variant="contained"
                    size='small'
                    onClick={() => onConfirm(MembershipModes.MembershipAndForceSubscription)}
                    color="primary">

                                        <Typography variant='caption'>{t(`Subscription.SubscriptionAssignment.UserAlreadyHasSubscriptionOfTypeFromOrganization.AssignAnyway`)}</Typography>
                </Button>

                        <Button variant="contained"
                    size='small'
                    onClick={() => onConfirm(MembershipModes.MembershipOnly)}
                    color="primary">
                                <Typography variant='caption'>{t(`Subscription.SubscriptionAssignment.UserAlreadyHasSubscriptionOfTypeFromOrganization.AddWithoutSubscription`)}</Typography>
            </Button>
                        <Button variant="outlined"
                    size='small'
                    onClick={onCancel}
                    color="primary">
                                <Typography variant='caption'>{t(`Subscription.SubscriptionAssignment.RemoveUser`)}</Typography>
            </Button>
        </Grid>
    </Grid>;
};


export default ChooseMembershipMode;
